import { Modal } from 'antd';
import type { ModalFuncProps } from 'antd/lib/modal';

/** Modal.confirm as a promise; `decline` closes it as Cancel does (destroy() alone fires no onCancel). */
export const askToConfirm = (
  props: Omit<ModalFuncProps, 'onOk' | 'onCancel'>,
): { answer: Promise<boolean>; decline: () => void } => {
  let settle: (ok: boolean) => void = () => undefined;
  const answer = new Promise<boolean>((resolve) => {
    settle = resolve;
  });
  const modal = Modal.confirm({ ...props, onOk: () => settle(true), onCancel: () => settle(false) });
  return {
    answer,
    decline: () => {
      modal.destroy();
      settle(false);
    },
  };
};
